// @flow

import React, { Component } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import type { RencontreActionType } from 'types/Rencontre';

type State = {
  isOpen: boolean,
  noScore: boolean,
};

type Props = {
  localActionsNumber: number,
  visiteurActionNumber: number,
  localActions: RencontreActionType[],
  visiteurActions: RencontreActionType[],
  actionType: string,
  isLocal: boolean
}

export default class RencontreStatRow extends Component<Props, State> {
  state: State = {
    isOpen : false,
    noScore: false,
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    const { localActionsNumber, visiteurActionNumber } = nextProps;
    const { noScore } = prevState;

    if ((visiteurActionNumber > 0 || localActionsNumber > 0) && noScore) {
      return { noScore: false };
    }

    return null;
  }

  componentDidMount() {
    const {
      localActionsNumber,
      visiteurActionNumber
    } = this.props;

    if (visiteurActionNumber === 0 && localActionsNumber === 0) {
      this.setState({ noScore: true });
    }
  }

  handleClick = () => {
    const { noScore } = this.state;
    if (noScore) return false;
    return this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  renderScoreBodyInfos = (actions: RencontreActionType[]): React$Element<'p'>[] => {
    return actions.sort(function(a, b){
        if (a.minutes < b.minutes) return -1;
        if (a.minutes > b.minutes) return 1;
        return 0;
    }).map((action: RencontreActionType): React$Element<'p'> => {
      return (
        <p key={action.id}>
          {action.joueur ? 
            (action.joueur.prenom + ' '+ action.joueur.nom) : 
            (action.sousType === 'De pénalité' ? 'Essai de pénalité' : '')
          }
          <span>{`${action.minutes}'`}</span>
        </p>
      );
    });
  };

  getProgressWidth = (localActionsNumber: number, visiteurActionNumber: number) => {
    const total = localActionsNumber + visiteurActionNumber;
    if (localActionsNumber === 0) {
      return `0%`;
    }

    return `${(localActionsNumber / total) * 100}%`;
  };

  render() {
    const { isOpen, noScore } = this.state;
    const {
      localActions,
      visiteurActions,
      localActionsNumber,
      visiteurActionNumber,
      actionType,
      isLocal,
    } = this.props;

    const classNames = dynamicClassName('');
    const scoreBodyClassNames = dynamicClassName('score__body');
    const scoreHeadLocalClassNames = dynamicClassName('score__head__int');
    const scoreHeadVisiteurClassNames = dynamicClassName('score__head__ext');
    const scoreContainerClassname = dynamicClassName('score');

    let progressClassNames = '';

    if (isOpen) {
      classNames.add('is-open');
    } else {
      classNames.add('is-close');
      scoreBodyClassNames.add('is-hidden');
    }

    if (noScore) {
      scoreContainerClassname.add('is-disabled');
    }

    if (isLocal === false) {
      progressClassNames = 'is-right';
    }

    if (localActionsNumber > visiteurActionNumber) {
      scoreHeadLocalClassNames.add('is-superior');
    } else if (visiteurActionNumber > localActionsNumber) {
      scoreHeadVisiteurClassNames.add('is-superior');
    }

    const seeDetailButtonClasses = noScore ? '' : classNames.build().trim();
    const title = actionType.replace('carton', 'cartons');
    if (localActionsNumber === 0 && visiteurActionNumber === 0) {
      return '';
    }
    return (
      <div className={scoreContainerClassname.build()}>
        <div className="score__head">
          {/* eslint-disable-next-line */}
          <a className={seeDetailButtonClasses} role="button" tabIndex={0} onClick={this.handleClick}>
            {`${title.charAt(0).toUpperCase()}${title.slice(1)}s`}
          </a>
          <span className={scoreHeadLocalClassNames.build()}>
            {localActionsNumber}
          </span>
          <div>
            <span
              className={progressClassNames}
              style={{ width: this.getProgressWidth(isLocal ? localActionsNumber : visiteurActionNumber, isLocal ? visiteurActionNumber : localActionsNumber) }}>
            </span>
          </div>
          <span className={scoreHeadVisiteurClassNames.build()}>
            {visiteurActionNumber}
          </span>
        </div>
        <div className={scoreBodyClassNames.build()}>
          <div>
            {this.renderScoreBodyInfos(localActions)}
          </div>
          <div>
            {this.renderScoreBodyInfos(visiteurActions)}
          </div>
        </div>
      </div>
    );
  }
}
